const { default: Axios } = require('axios');

module.exports = {
    props: ['user', 'team'],

    data() {
        return {
            form: new SparkForm({
                rating_preference: 'standard',
            }),
        };
    },

    mounted() {
        // Fetch the team's rating preference when the component is mounted
        this.getTeamPreference();
    },

    methods: {
        // Fetch the rating preference from the server
        getTeamPreference() {
            Axios.get(`/settings/${Spark.teamsPrefix}/${this.team.id}/preferences`)
                .then((response) => {
                    this.form.rating_preference = response.data.rating_preference;
                })
                .catch((error) => {
                    console.error('Error while fetching preferences:', error);
                });
        },

        // Update the rating preference
        update() {
            this.form.startProcessing();

            Axios.put(`/settings/${Spark.teamsPrefix}/${this.team.id}/preferences`, {
                rating_preference: this.form.rating_preference,
            })
                .then(() => {
                    Bus.$emit('updateTeam');
                    Bus.$emit('updateTeams');
                    this.form.successful = true;
                })
                .catch((error) => {
                    console.error('Error while updating preferences:', error);

                    if (error.response?.data?.errors) {
                        this.form.setErrors(error.response.data.errors);
                    } else {
                        this.form.setErrors({
                            general: ['An error occurred while updating the preferences.'],
                        });
                    }
                });
        },
    },
};
